<template>
  <el-dialog
    width="540px"
    :title="title"
    :visible.sync="visible"
    :close-on-click-modal="false"
  >
    <el-form
      :model="form"
      :rules="formRules"
      ref="labelForm"
      label-width="100px"
    >
      <el-form-item label="标签名称" prop="labelName">
        <el-input
          v-model="form.labelName"
          placeholder="请填写"
          maxlength="50"
        ></el-input>
      </el-form-item>
      <el-form-item label="上级标签">
        <el-select
          v-model="form.parentGuid"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="item in labelList"
            :key="item.guid"
            :label="item.labelName"
            :value="item.guid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="界面排序">
        <el-input
          v-model="form.sort"
          placeholder="若不填写则系统自动+1生成"
        ></el-input>
      </el-form-item>
      <el-form-item label="启用状态" prop="bizState" style="text-align: left">
        <el-radio-group v-model="form.bizState">
          <el-radio label="Y">启用</el-radio>
          <el-radio label="N">停用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" plain @click="handleCancel">取 消</el-button>
      <el-button size="medium" type="info" @click="handleSubmit"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "LabelDialog",
  props: {
    title: {
      type: String,
      default: "新增题目标签",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({
        labelName: "",
        parentGuid: "",
        sort: "",
        bizState: "Y",
      }),
    },
    labelList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formRules: {
        labelName: [
          { required: true, message: "请填写标签名称", trigger: "blur" },
          { max: 15, message: "标签名称不能超过15个字符", trigger: "change" },
        ],
        bizState: [
          { required: true, message: "请选择启用状态", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    handleCancel() {
      this.$emit("update:visible", false);
    },
    handleSubmit() {
      this.$refs.labelForm.validate((valid) => {
        if (valid) {
          this.$emit("submit", this.form);
        }
      });
    },
  },
};
</script>

<style scoped></style>
